import { render, staticRenderFns } from "./AppointmentNavigation.vue?vue&type=template&id=27adcb7a&scoped=true&"
import script from "./AppointmentNavigation.vue?vue&type=script&lang=ts&"
export * from "./AppointmentNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentNavigation.vue?vue&type=style&index=0&id=27adcb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27adcb7a",
  null
  
)

export default component.exports